'use client';

import Script from 'next/script';

interface ScriptDigineticaPropsProps {
  siteId?: string;
}

export const ScriptDiginetica = ({ siteId }: ScriptDigineticaPropsProps) => {
  const src = `https://cdn.diginetica.net/${siteId}/client.js`;
  return (
    <>
      <link
        rel="preconnect"
        href="https://cdn.diginetica.net/"
      />
      <link
        rel="preconnect"
        href="https://tracking.diginetica.net/"
      />
      <link
        rel="preconnect"
        href="https://tracking-app.diginetica.net/"
      />
      <Script
        src={src}
        async
        defer
        onLoad={() => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          window.digiLayer = window.digiLayer || {};
        }}
      />
    </>
  );
};
